import { Common } from './Common.js';

var AreaAddEditVM = function (jsonData) {
  var self = this;
  if (RazorShared.isDebug) console.log('AreaAddEditVM locator');

  self.$container = $(document);
  self.$form = $('');
  self.okCallback = function () {};
  self.Area = null;
  self.AddEditText = '';

  self.init = function ($dlgcontainer, params) {
    if ($dlgcontainer) {
      self.$container = $dlgcontainer;
      self.$form = self.$container.find('form');
    }

    if (params.okCallback) {
      self.okCallback = params.okCallback;
    }

    self.load(AreaAddEditVM.jsonData);
  };

  self.load = function (jsonData) {
    self.Area = new AreaVM(jsonData.Area);

    self.AddEditText = self.Area.AreaID ? 'Edit Area: ' + self.Area.Name() : 'Add Area';

    ko.applyBindings(self, self.$container[0]);

     self.$form.on('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
     });

     var $input = self.$form.find('#Name');
     $input.on('keyup', function (e) {
        if (e.which === 13) {
           e.stopPropagation();
           e.preventDefault();
           self.Save()          
        }
     });
  };

   self.Save = function () {
      if (!self.$form.validate().form()) return;
      $.post(RazorShared.baseUrl + 'LocationMgmt/SaveArea', self.$form.serialize(), function (data) {
         if (!data.success) {
            Common.Dialog('Error saving area', null, data.error);
         } else {        
            self.okCallback();           
         }
         self.$container.modal('hide');
      }).fail(function (xhr, textStatus, errorThrown) {
         Common.Dialog('Save Area', textStatus + '/' + errorThrown, null, xhr.status);
      });  
  };
};

var AreaVM = function (jsonData) {
  var self = this;

  self.AreaID = jsonData.AreaID || 0;
  self.Name = ko.observable(jsonData.Name || '');
};

export default AreaAddEditVM;
